export function AddAttachment(organizationID: number, ID: number, attachmentID: number): string {
	return `/v1/organizations/${organizationID}/exercises/${ID}/attachments/${attachmentID}`;
}

export function AddTag(organizationID: number, ID: number, tagID: number): string {
	return `/v1/organizations/${organizationID}/exercises/${ID}/tags/${tagID}`;
}

export function BulkUpdateGroupShare(organizationID: number): string {
	return `/v1/organizations/${organizationID}/exercises/group-share`;
}

export function BulkUpdateOrganizationShare(organizationID: number): string {
	return `/v1/organizations/${organizationID}/exercises/share`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/exercises`;
}

export function CreateDrawing(organizationID: number): string {
	return `/v1/organizations/${organizationID}/exercises/drawings`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/exercises/${ID}`;
}

export function DeleteDrawing(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/exercises/drawings/${ID}`;
}

export function Duplicate(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/exercises/${ID}/duplicate`;
}

export function GroupShareIndex(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/exercises/${ID}/group-share`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/exercises`;
}

export function RemoveAttachment(organizationID: number, ID: number, attachmentID: number): string {
	return `/v1/organizations/${organizationID}/exercises/${ID}/attachments/${attachmentID}`;
}

export function RemoveTag(organizationID: number, ID: number, tagID: number): string {
	return `/v1/organizations/${organizationID}/exercises/${ID}/tags/${tagID}`;
}

export function ShareIndex(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/exercises/${ID}/share`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/exercises/${ID}`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/exercises/${ID}`;
}

export function UpdateDrawing(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/exercises/drawings/${ID}`;
}

export function UpdateOrganizationShare(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/exercises/${ID}/share`;
}

